import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import Drp_ProductGroup from '../ProductGroup/Drp_Group';
import Drp_ProductParentGroup from '../ProductGroup/Drp_Group';
import Auto_Product from '../Product/Auto_Product';
import Drp_StoreRoom from './Drp_StoreRoom';
import Modal_ProductCardex from '../CardexReport/Modal_ProductCardex'
import PN from "persian-number";



const StorRoomInventoryExistIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'id';
    let navigate = useNavigate();
    const ProductRef = useRef()
    const GroupRef = useRef()
    const StoreRef = useRef()
    const ProductCardexRef = useRef()
    const ParentGroupRef = useRef()
    const [List, setList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [GroupId, setGroupId] = useState("-1");
    const [GroupParentId, setGroupParentId] = useState("-1");
    const [ProductTitle, setProductTitle] = useState('');
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    //#region Tabe Setting
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    const CompactCell = props => <rsuite.Table.Cell {...props} style={{ padding: 4 }} />;
    const CompactHeaderCell = props => <rsuite.Table.HeaderCell {...props} style={{ padding: 4 }} />;
    const defaultColumns = [
        {
            key: 'row',
            label: '#',
            fixed: true,
            sortable: true,
            width: 50,
            defaultOn: true

        },
        {
            key: 'IsDeleted',
            label: 'وضعیت',
            fullText: true,
            sortable: true,
            fixed: true,
            width: 100,
            defaultOn: true

        },

        {
            key: 'StoreRoom',
            label: 'انبار',
            fullText: true,
            sortable: true,
            fixed: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'Product',
            label: 'محصول',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            flexGrow: 1,
            defaultOn: true

        },
        {
            key: 'IdentityNo',
            label: 'شناسه محصول',
            fixed: true,
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },
        {
            key: 'UpdateDate',
            label: ' تاریخ به روز رسانی',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 100,
            defaultOn: true

        },



        {
            key: 'PhysicalCount',
            label: 'موجودی فیزیکی ',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 150,
            defaultOn: true

        },
        {
            key: 'SaleCount',
            label: 'موجودی قابل فروش ',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 150,
            defaultOn: true

        },
        {
            key: 'Price',
            label: 'ارزش محصولات در انبار',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 200,
            defaultOn: true
        },
        {
            key: 'MaxPrice',
            label: 'آخرین قیمت خرید',
            fullText: true,
            resizable: true,
            sortable: true,
            width: 200,
            defaultOn: false
        }
    ];

    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };
    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };


    const [compact, setCompact] = React.useState(true);
    const [columnKeys, setColumnKeys] = React.useState(defaultColumns.map(column => column.key));

    const columns = defaultColumns.filter(column => columnKeys.some(key => key === column.key));
    const CustomCell = compact ? CompactCell : rsuite.Table.Cell;
    const CustomHeaderCell = compact ? CompactHeaderCell : rsuite.Table.HeaderCell;
    const [limit, setLimit] = React.useState(30);
    const [page, setPage] = React.useState(1);
    //#endregion
    //#endregion



    const Product_Select = (e) => {
        setProductId(e.split("|")[0])
        setProductTitle(e.split("|")[1])
    }

    const Product_Change = (e) => {
        setProductId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setProductTitle(e.split("|")[1]);
            setProductId(e.split("|")[0])
            return;
        }
        setProductTitle(e);
        ProductRef.current.Bind(GroupParentId, GroupId, e)

    }


    const Parent_Change = (value) => {
        setGroupParentId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        setGroupId("-1");
        GroupRef.current.BindGroupByParentId(0, value);
        ProductRef.current.Bind(value, -1, '')
    }

    const Group_Change = (value) => {
        setGroupId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        ProductRef.current.Bind(GroupParentId, value, '')
    }

    //#region Methods


    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReport/GetExistance_Report', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'ProductId': ProductId,
                    'GroupId': GroupId,
                    'GroupParentId': GroupParentId,
                    'FiscalYearId': FiscalYearId,
                    'StoreRoomId': StoreRoomId,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []

                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Price: PN.sliceNumber(result[i].price),
                            MaxPrice: PN.sliceNumber(result[i].maxPrice),
                            PhysicalCount: result[i].physicalCount,
                            SaleCount: result[i].saleCount,
                            Product: result[i].product,
                            ProductId: result[i].productId,
                            StoreRoomId: result[i].storeRoomId,
                            IdentityNo: result[i].identityNo,
                            StoreRoom: result[i].storeRoom,
                            IsDeleted: result[i].isDeleted == 0 ? "" : " حذف شده ",
                            UpdateDate: result[i].updateDate,

                        })
                    }
                    setList(tmp)
                })
        )
    }






    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 60);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                        StoreRef.current.Bind(-1);
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const ShowProductCardex = (id, storeRoomId, product, storeRoom) => {
        ProductCardexRef.current.Bind(id, storeRoomId, product, storeRoom)
    }



    useEffect(() => {
        CheckPermission();
        document.title = "گزارش موجودی انبار";
    }, [])
    //#endregion







    return (

        <Layout title=" گزارش موجودی انبار">


            <div className="h-100">
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />

                    <rsuite.Row >

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>انبار</label>
                            <Drp_StoreRoom className='rs-input' value={StoreRoomId} onChange={(e) => setStoreRoomId(e)} ref={StoreRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ProductParentGroup className="rs-input" value={GroupParentId} onChange={Parent_Change} ref={ParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_ProductGroup className="rs-input" value={GroupId} onChange={Group_Change} ref={GroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> محصول   </label>
                            <Auto_Product className="rs-input" value={ProductTitle} onChange={Product_Change} onSelect={Product_Select} ref={ProductRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <label> فیلتر   </label>
                            <rsuite.VStack spacing={16}>

                                <rsuite.TagPicker
                                    data={defaultColumns}
                                    labelKey="label"
                                    valueKey="key"
                                    value={columnKeys}
                                    onChange={setColumnKeys}
                                    cleanable={false}
                                    className='Font10 w-100p'
                                />
                            </rsuite.VStack>
                        </rsuite.Col>
                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">
                            <rsuite.Panel className="bg-white mt-2">


                                <rsuite.Table


                                    height={500}
                                    // data={List}
                                    loading={loading}
                                    data={List.sort((a, b) => {
                                        let x = a[sortColumn];
                                        let y = b[sortColumn];
                                        if (typeof x === 'string') {
                                            x = x.charCodeAt();
                                        }
                                        if (typeof y === 'string') {
                                            y = y.charCodeAt();
                                        }
                                        if (sortType === 'asc') {
                                            return x - y;
                                        } else {
                                            return y - x;
                                        }
                                    }).filter((v, i) => {
                                        const start = limit * (page - 1);
                                        const end = start + limit;
                                        return i >= start && i < end;
                                    })}
                                    sortColumn={sortColumn}
                                    sortType={sortType}
                                    onSortColumn={handleSortColumn}


                                >
                                    {columns.map(column => {
                                        const { key, label, ...rest } = column;
                                        return (
                                            <rsuite.Table.Column {...rest} key={key} >
                                                <CustomHeaderCell>{label}</CustomHeaderCell>
                                                <rsuite.Table.Cell {...rest} dataKey={key}>
                                                    {rowData => {
                                                        let dynamicClass = "";

                                                        if (rowData.IsDeleted == "") {
                                                            dynamicClass = "";
                                                        } else {
                                                            dynamicClass = "text-danger";
                                                        }

                                                        return <span className={`${dynamicClass}`}>{rowData[key]}</span>;
                                                    }}
                                                </rsuite.Table.Cell>
                                            </rsuite.Table.Column>
                                            // <rsuite.Table.Column {...rest} key={key}>
                                            //     <CustomHeaderCell>{label}</CustomHeaderCell>
                                            //     <CustomCell dataKey={key} />
                                            // </rsuite.Table.Column>
                                        );
                                    })}
                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item onClick={() => ShowProductCardex(rowData.ProductId, rowData.StoreRoomId, rowData.Product, rowData.StoreRoom)}>چاپ</rsuite.Dropdown.Item>
                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>


                                </rsuite.Table>

                                <div style={{ paddingTop: 20 }}>
                                    <rsuite.Pagination
                                        prev
                                        next
                                        first
                                        last
                                        ellipsis
                                        boundaryLinks
                                        maxButtons={5}
                                        size="xs"
                                        layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                                        total={List.length}
                                        limitOptions={[10, 30, 50, 100]}
                                        limit={limit}
                                        activePage={page}
                                        onChangePage={setPage}
                                        onChangeLimit={handleChangeLimit}
                                    />
                                </div>
                            </rsuite.Panel>

                        </div>
                    </div>

                </rsuite.Panel >
            </div >
            <Modal_ProductCardex ref={ProductCardexRef} />

        </Layout >
    )
}

export default StorRoomInventoryExistIndex;